import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import { scssVariables as variables, remCss, lang, withRouter } from 'src/helpers';

import Speciality from './Speciality';
import Qualifications from './Qualifications';
import Treatments from './Treatments';
import Charges from './Charges';
import ChatTicket from './ChatTicket';
import Certificate from './Certificate';

import model from './model';
import Schedule from './Schedule';

const style = {};

style.backgroundColor = variables['colors-mc-white'];

class SignupDoctorPopup extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    let step = model.state.step;
    let steps = [
      Speciality,
      Qualifications,
      Treatments,
      Charges,
      ChatTicket,
      Schedule,
      Certificate
    ];
    let titles = [
      'Speciality',
      'Qualifications',
      'Treatments',
      'Consultation Charges',
      'Chat Ticket',
      'Schedule',
      'Certificates'
    ];
    let Component = steps[step];
    const { hide } = this.props;
    return (
      <div
        className='mc-popup-contain mc-popup-signup-doctor'
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: remCss(1024),
          height: '95%',
          maxHeight: remCss(1060)
        }}
      >
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t(titles[step])}</div>
        </div>
        <Component
          auth={model.state.user}
          showBtns={true}
          next={() => {
            if (step < steps.length - 1) {
              model.setState({ step: step + 1 });
            } else {
              this.props.router.navigate('/settings/certificate');
              hide();
            }
          }}
          prev={step > 0 ? () => model.setState({ step: step - 1 }) : null}
          labelNext={step === steps.length - 1 ? 'Finish' : 'Next'}
          close={hide}
        />
      </div>
    );
  }
}

export default withRouter(SignupDoctorPopup);
